import Member3D from "./Member3D";
import { Canvas } from "@react-three/fiber";
import { useRef, useState, useEffect, useMemo } from "react";
import Fuse from "fuse.js";
import { AutoComplete } from "antd";
import "./MemberCanvas.css";
import Member3DIntroduction from "./Introduction";

function MemberCanvas(props) {
  const Member3dRef = useRef();
  const [pictureList, setPictureList] = useState([]);
  const [query, setQuery] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [showConsole, setShowConsole] = useState(false);
  const [showClaim, setShowClaim] = useState(true);
  const [showIntro, setShowIntro] = useState(false);

  useEffect(() => {
    props.setLoaded(false);
    let timeout2Id = setTimeout(() => {
      setShowClaim(false);
      props.setLoaded(true);
    }, 2000);

    let isMounted = true;
    let timeoutId = null;

    const initializeImageList = () => {
      if (!isMounted) return;
      let imageList = [];
      if (Member3dRef.current) {
        imageList = Member3dRef.current.getImageList();
      }
      if (imageList.length === 0) {
        timeoutId = setTimeout(initializeImageList, 1000);
        return;
      }
      setPictureList(imageList);
    };

    initializeImageList();

    return () => {
      isMounted = false;
      if (timeoutId) clearTimeout(timeoutId);
      if (timeout2Id) clearTimeout(timeout2Id);
    };
  }, []);

  const fuse = useMemo(() => {
    if (pictureList.length === 0) {
      return null;
    }
    return new Fuse(pictureList, {
      keys: ["name"],
      threshold: 0.5,
      minMatchCharLength: 1,
      includeScore: true,
    });
  }, [pictureList]);

  const searchResult = useMemo(() => {
    if (!query.trim() || !fuse) {
      return [...(pictureList || [])].sort((a, b) =>
        a.name.localeCompare(b.name, "zh-CN"),
      );
    }
    const fuseResults = fuse.search(query);
    const sortedResults = fuseResults.sort((a, b) => {
      if (Math.abs(a.score - b.score) > 0.2) {
        return a.score - b.score;
      }
      return a.item.name.localeCompare(b.item.name, "zh-CN");
    });

    return sortedResults.map((result) => result.item);
  }, [query, fuse, pictureList]);

  const searchOptions = useMemo(() => {
    return searchResult.map((item) => ({
      value: item.id.toString(),
      label: item.name,
    }));
  }, [searchResult]);

  return (
    <div className="member3d-canvas" style={{ pointerEvents: "inherit" }}>
      <div
        className="member3d-help-button"
        onClick={() => setShowIntro(true)}
        title="使用说明"
      >
        <i className="fas fa-question-circle"></i>
      </div>
      {/* 引导弹窗 */}
      {showIntro && (
        <Member3DIntroduction onClose={() => setShowIntro(false)} />
      )}

      <div
        className="member3d-console-container"
        style={{ left: showConsole ? 0 : "-18rem" }}
      >
        <AutoComplete
          getPopupContainer={(triggerNode) => triggerNode.parentElement}
          className="member3d-search-ac"
          options={searchOptions}
          showSearch={{ onSearch: (v) => setQuery(v) }}
          value={selectedValue}
          onChange={(v) => setSelectedValue(v)}
          onSelect={(value, option) => {
            setSelectedValue(option.label);
            if (Member3dRef.current) {
              Member3dRef.current.focusOnImage(option.value, {
                smoothTransition: true,
                resetZoom: true,
              });
            }
          }}
          placeholder="/locate（"
        ></AutoComplete>
        <div
          className="member3d-console-showCtrl"
          onClick={() => setShowConsole(showConsole ? false : true)}
        >
          <i className={`fas fa-angle-${showConsole ? "left" : "right"}`}></i>
        </div>
      </div>
      {/* <div className="member3d-claim" style={{ opacity: showClaim ? 1 : 0 }}>
        咱技术有限，某些性能差的设备加载的时候会卡一段时间（
      </div> */}
      <Canvas style={{ pointerEvents: "inherit" }}>
        <Member3D
          ref={Member3dRef}
          atlasTextureUrl="https://api1.ororigin.xyz/static/avatar_atlas.png"
          atlasJsonUrl="https://api1.ororigin.xyz/static/avatar_atlas.json"
        ></Member3D>
      </Canvas>
    </div>
  );
}

export default MemberCanvas;
